'use client';
import { styles } from './balance-info.style';
import Image from 'next/image';
import { useAccountInfo } from '@/hooks/query/account';
import { useTranslations } from 'next-intl';
import { useRef } from 'react';
import { useOuterClick } from '@nf/utils-common/hooks';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { KafkaNote } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import clsx from 'clsx';
import { useSiteStore } from '@/store/site';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
type BalanceInfoProps = {
	setShowBalanceInfo: (showBalance: boolean) => void;
}

export function BalanceInfo({ setShowBalanceInfo }: BalanceInfoProps) {
	const { SiteConfigsData } = useGetSiteConfigs();
	const t = useTranslations('General');
	const { user } = useAccountInfo();
	const view = useAppearanceStore(state => state.view);
	const showBalanceInfoRef = useRef<HTMLDivElement>(null);
	const [isShowBalance, setIsShowBalance] = useSiteStore(state => [state.isShowBalance, state.setIsShowBalance]);

	useOuterClick(showBalanceInfoRef, () => setShowBalanceInfo(false));

	/** show / hide balance when width < 750 */
	const switchShowBalance = () => {
		setKafka();
		setIsShowBalance(!isShowBalance)
	}

	const setKafka = () => {
		if (view !== ViewEnum.mars) return; // 目前僅支援 mars

		const kafkaData = {
			note: KafkaNote.MarsV1,
			type: 2,
			action: isShowBalance ? 5 : 4 // 5: switch off, 4: switch on
		}
		setKafkaNormal(kafkaData);
	}

	if (view !== ViewEnum.mars) return null; // 此元件僅支援 mars 版面

	return (
		<>
			{
				(user?.CanSeeAvailableFunds || user?.CanSeePendingFunds) &&
				<div className={styles.balanceInfo} ref={showBalanceInfoRef}>
					{
						user?.CanSeeAvailableFunds &&
						<div className={styles.switch}>
							<span className={styles.switchText}>{t('lbl_ShowBalance')}</span>
							<div
								className={styles.switchBtn}
								data-active={isShowBalance}
								onClick={switchShowBalance}
							>
								<div className={styles.switchDot}></div>
							</div>
						</div>
					}
					{/* TODO: SABA Coin 新版面 */}
					<div className={styles.list}>
						{
							user?.CanSeeAvailableFunds &&
							<div className={clsx(styles.listItem, styles.heading)}>
								<div className={styles.title}>{t('lbl_AvailableFunds')}</div>
								<div className={styles.currency}>{user?.LicenseeSiteSetting?.DisplayCurrencyName}</div>
								<div className={styles.value}>{user?.BCredit}</div>

							</div>
						}
						{
							user?.CanSeePendingFunds &&
							<div className={styles.listItem}>
								<div className={styles.title}>{t('lbl_PendingFunds')}</div>
								<div className={styles.currency}>{user?.LicenseeSiteSetting?.DisplayCurrencyName}</div>
								<div className={styles.value}>{user?.OutSd}</div>
							</div>
						}
						{
							!user?.SabaCoinWallet ? null : (
								<>
									<div className={clsx(styles.listItem, styles.heading)}>
										<div className={styles.title}>{t('lbl_RPSabaCoins')}</div>
										<div className={styles.currency}>{SiteConfigsData?.EnableCurrencyDisplay ? 'SBC' : ''}</div>
										<div className={styles.value}>
											<Image
												src="/images/coin-icon.svg"
												alt=""
												width="16"
												height="16"
												className={styles.icon}
											/>
											{user.SabaCoinWallet.AvailableFund}
										</div>
									</div>
									<div className={styles.listItem}>
										<div className={styles.title}>{t('lbl_RPPSabaCoins')}</div>
										<div className={styles.currency}>{SiteConfigsData?.EnableCurrencyDisplay ? 'SBC' : ''}</div>
										<div className={styles.value}>
											<Image
												src="/images/coin-icon.svg"
												alt=""
												width="16"
												height="16"
												className={styles.icon}
											/>
											{user.SabaCoinWallet.PendingFund}
										</div>
									</div>
								</>
							)
						}
					</div>
				</div>
			}
		</>
	)
}